<template>
    <el-amap
        vid="amapDemo"
        :center="location"
        :zoom="14"
        class="amap-demo"
        >
        <el-amap-marker
            vid="component-marker"
            :position="componentMarker.position"
        ></el-amap-marker>
        <el-amap-info-window
            :position="componentMarker.position"
            :offset="componentMarker.offset"
            :content="componentMarker.content"
        >
        </el-amap-info-window>
    </el-amap>

</template>
  
  <script>
  import { AMapManager } from "vue-amap";
  export default {
    props: {
        location:{
            type:Array,
            default:()=>{}
        },
        componentMarker: {
            type: Object,
            default:{
                position: [],
                content: "菁蓉汇",
                offset: [0, -26]
            }
        }
    },
    data(){
        return{
            amapManager: new AMapManager(),
        }
    },
    components: {
     
    },
    methods:{}
  };
  </script>
  
  <style lang="scss" scoped>
        .amap-demo {
            width: 100%;
            height: 360px;
        }
  
  </style>
  